// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Cofre_ExtratoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for extrato() — GET /cofre/extrato/:id
 *
 * Lista as sangrias transferidas para esta conta — não é um saldo corrente.
 */
import type { Cofre_ExtratoItemRow } from './Cofre_ExtratoItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Cofre_ExtratoResponseDados {
items: Cofre_ExtratoItemRow[]
}

export type Cofre_ExtratoResponse = ApiResponse<Cofre_ExtratoResponseDados>;

registerResponseContract('Cofre_ExtratoResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: false },
      caixa_abertura_id: { type: 'number',  required: false },
      tipo:              { type: 'string',  required: false },
      forma_pagamento:   { type: 'string',  required: false },
      cofre_id:          { type: 'number',  required: false },
      valor:             { type: 'string',  required: false },
      entrada_saida:     { type: 'string',  required: false },
      saldo_antes:       { type: 'string',  required: false },
      saldo_depois:      { type: 'string',  required: false },
      origem:            { type: 'string',  required: false },
      origem_id:         { type: 'number',  required: false },
      observacao:        { type: 'string',  required: false },
      conferido:         { type: 'number',  required: false },
      operador_id:       { type: 'number',  required: false },
      created_at:        { type: 'string',  required: false },
      updated_at:        { type: 'string',  required: false },
      deleted_at:        { type: 'string',  required: false },
    },
  },
})
